import PropTypes from 'prop-types';
import * as React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import {Dropdown, DropdownButton} from 'react-bootstrap';
import {connect} from 'react-redux';
import * as issuesActions from '../../actions/arr/issues';
import {modalDialogHide, modalDialogShow} from '../../actions/global/modalDialog';
import * as perms from '../../actions/user/Permission';
import {WebApi} from '../../actions/WebApi';
import {Button} from '../../components/ui';
import objectById from '../../shared/utils/objectById';
import storeFromArea from '../../shared/utils/storeFromArea';
import IssueForm from '../form/IssueForm';
import { FormattedMessage, injectIntl } from 'react-intl';
import { globalMessages } from 'components/shared/lang/messages';
import { daoMessages } from 'components/arr/daoMessages';
import Icon from '../shared/icon/Icon';
import Loading from '../shared/loading/Loading';
import {dateTimeToString} from '../Utils';

import './LecturingBottom.scss';

/**
 * Spodní část lektoringu, zajištující seznam komentářů, komentování a editaci
 */
class LecturingBottom extends React.Component<any> {
    static propTypes = {
        fund: PropTypes.object.isRequired,
    };

    state: any = {
        text: '',
        comment: null,
        submitting: false,
        actualFundId: null,
    };

    componentDidMount() {
        const {issueDetail, fund} = this.props;
        if (issueDetail && issueDetail.id) {
            this.props.dispatch(issuesActions.detail.fetchIfNeeded(issueDetail.id));
            this.props.dispatch(issuesActions.comments.fetchIfNeeded(issueDetail.id));
        }

        const fundId = this.props.issueProtocols.filter.fundId;
        if (fundId !== null && fundId !== fund.id) {
            this.props.dispatch(issuesActions.detail.reset());
            this.props.dispatch(issuesActions.comments.reset());
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        const {issueDetail, fund} = nextProps;

        if (issueDetail && issueDetail.id) {
            this.props.dispatch(issuesActions.detail.fetchIfNeeded(issueDetail.id));
            this.props.dispatch(issuesActions.comments.fetchIfNeeded(issueDetail.id));
        }

        if (fund.id !== this.props.fund.id) {
            this.props.dispatch(issuesActions.detail.reset());
            this.props.dispatch(issuesActions.comments.reset());
        }
    }

    addComment = nextStateId => {
        const {
            issueDetail: {id},
        } = this.props;
        this.setState({submitting: true});
        WebApi.addIssueComment({issueId: id, comment: this.state.text, nextStateId}).then(this.afterSave);
    };

    editComment = (comment: any) => {
        this.setState({comment, text: comment.comment});
    };

    reset = () => {
        this.setState({text: '', submitting: false, comment: null});
    };

    afterSave = (stateChanged = false) => {
        this.reset();
        this.props.dispatch(issuesActions.comments.invalidate(this.props.issueDetail.id));
        if (stateChanged) {
            this.props.dispatch(issuesActions.detail.invalidate(this.props.issueDetail.id));
            this.props.dispatch(issuesActions.list.invalidate(this.props.issueDetail.issueListId));
        }
    };

    updateComment = () => {
        const {comment, text} = this.state;
        this.setState({submitting: true});
        WebApi.updateIssueComment(comment.id, {...comment, comment: text}).then(this.afterSave.bind(this, true));
    };

    editIssue = () => {
        const {dispatch, issueDetail} = this.props;
        dispatch(
            modalDialogShow(
                this,
                this.props.intl.formatMessage(daoMessages.issuesUpdateTitle),
                <IssueForm
                    // @ts-ignore
                    update
                    initialValues={issueDetail.data}
                    onSubmit={this.updateIssue}
                    onSubmitSuccess={() => {
                        dispatch(issuesActions.list.invalidate(issueDetail.issueListId));
                        dispatch(issuesActions.detail.invalidate(issueDetail.id));
                        dispatch(modalDialogHide());
                    }}
                />,
            ),
        );
    };

    updateIssue = data => {
        const {issueDetail} = this.props;
        return WebApi.updateIssue(issueDetail.data.id, {
            ...issueDetail.data,
            ...data,
        });
    };

    render() {
        const {fund, issueStates, issueDetail, issueComments, userDetail} = this.props;
        const {id, data, fetched, isFetching} = issueDetail;
        const {text, comment, submitting} = this.state;

        const canWrite = fetched && (
                userDetail.hasOne(perms.FUND_ISSUE_ADMIN_ALL, {type: perms.FUND_ISSUE_ADMIN, fundId: fund.id}) ||
                userDetail.permissionsMap?.[perms.FUND_ISSUE_LIST_WR]?.issueListIds.length > 0
            );
        const canUpdateIssue =
            userDetail.id === data?.userCreate?.id &&
            issueComments.fetched &&
            issueComments.rows.length === 0;

        let state: any = null;
        if (issueStates && issueStates.fetched && data) {
            state = objectById(issueStates.data, data.issueStateId);
        }

        const textFieldDisabled = submitting || (state && state.finalState);

        const CustomArea = TextareaAutosize as any;

        return (
            <div className="lecturing-bottom">
                {!id && <div className="text-center">{<FormattedMessage {...daoMessages.issuesChoose} />}</div>}
                {isFetching && <Loading />}
                {fetched && (
                    <div className="lecturing-bottom-container">
                        <div className="comments">
                            <div className="comment">
                                <div className="comment-text">{data.description}</div>
                                <div className="text-right">
                                    {canUpdateIssue && (
                                        <div className="pull-left">
                                            <Button variant={'action' as any} onClick={this.editIssue}>
                                                <Icon glyph="fa-pencil" />
                                            </Button>
                                        </div>
                                    )}
                                    {data.userCreate.username} ({dateTimeToString(new Date(data.timeCreated))})
                                </div>
                            </div>
                            {issueComments.rows.map((item: any, index, arr) => (
                                <div>
                                    <div className={'comment' + (userDetail.id === item.user.id ? ' text-muted' : '')}>
                                        <div className="comment-text">{item.comment}</div>
                                        <div className="text-right">
                                            {canWrite && userDetail.id === item.user.id && arr.length === index + 1 && (
                                                <div className="pull-left">
                                                    <Button
                                                        variant={'action' as any}
                                                        onClick={this.editComment.bind(this, item)}
                                                    >
                                                        <Icon glyph="fa-pencil" />
                                                    </Button>
                                                </div>
                                            )}
                                            {item.user.username} ({dateTimeToString(new Date(item.timeCreated))})
                                        </div>
                                    </div>
                                    {(item.nextStateId !== item.prevStateId || arr.length === index + 1) && (
                                        <div className="state-change">
                                            <Icon glyph="fa-angle-double-right" />{' '}
                                            {objectById(issueStates.data, item.nextStateId).name}
                                        </div>
                                    )}
                                </div>
                            ))}
                            {!issueComments.rows.length && (
                                <div className="state-change">
                                    <Icon glyph="fa-angle-double-right" /> {state && state.name}
                                </div>
                            )}
                        </div>
                        {canWrite && !comment && (
                            <div className="add-comment">
                                <div>
                                    <CustomArea
                                        className="form-control"
                                        maxRows={3}
                                        //rows={3}
                                        value={this.state.text}
                                        onChange={({target: {value}}: any) => this.setState({text: value})}
                                        //disabled={textFieldDisabled}
                                    />
                                </div>
                                <div className="text-right">
                                    <DropdownButton
                                        drop={'up'}
                                        align="end"
                                        title={<FormattedMessage {...daoMessages.issuesStateChange} />}
                                        variant={'action' as any}
                                        id="comment-state"
                                        disabled={!this.state.text} //disabled={!this.state.text || textFieldDisabled}
                                    >
                                        {issueStates.data
                                            .filter(i => i.id !== data.issueStateId)
                                            .map(i => (
                                                <Dropdown.Item key={i.id} onClick={this.addComment.bind(this, i.id)}>
                                                    {i.name}
                                                </Dropdown.Item>
                                            ))}
                                    </DropdownButton>
                                    <Button
                                        variant={'action' as any}
                                        disabled={!this.state.text || textFieldDisabled}
                                        onClick={this.addComment.bind(this, null)}
                                    >
                                        <Icon glyph="fa-arrow-circle-up" />
                                    </Button>
                                </div>
                            </div>
                        )}
                        {canWrite && comment && (
                            <div className="edit-comment">
                                <div>
                                    <CustomArea
                                        className="form-control"
                                        maxRows={12}
                                        rows={3}
                                        value={text}
                                        onChange={({target: {value}}: any) => this.setState({text: value})}
                                        disabled={submitting}
                                    />
                                </div>
                                <div className="text-right">
                                    <Button variant={'action' as any} disabled={submitting} onClick={this.reset}>
                                        {<FormattedMessage {...globalMessages.cancel} />}
                                    </Button>
                                    <Button
                                        variant={'action' as any}
                                        disabled={!this.state.text || submitting}
                                        onClick={this.updateComment}
                                    >
                                        <Icon glyph="fa-arrow-circle-up" />
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default connect((state: any) => {
    const { arrRegion } = state;
    return {
        issueTypes: state.refTables.issueTypes,
        issueStates: state.refTables.issueStates,
        issueProtocols: storeFromArea(state, issuesActions.AREA_PROTOCOLS),
        issueDetail: storeFromArea(state, issuesActions.AREA_DETAIL),
        issueComments: storeFromArea(state, issuesActions.AREA_COMMENTS),
        userDetail: state.userDetail,
    };
})(injectIntl(LecturingBottom));
